import axios from '../../../../shared/axios/axios';
import * as actionTypes from './actionTypes';
import { apiOptions } from '../../../../shared/constants/apiOptions';
import { isGuid } from '../../../../shared/utils';

const getFilesInfoStart = () => {
  return {
    type: actionTypes.GET_FILES_INFO,
  };
};

const getFilesInfoSuccess = (data) => {
  return {
    type: actionTypes.GET_FILES_INFO_SUCCESS,
    selectedFilesInfo: data,
  };
};

const getFilesInfoFail = (error) => {
  return {
    type: actionTypes.GET_FILES_INFO_FAIL,
    error: error,
  };
};

export const getFilesInfo = (fileIds, receiptId, receiptIsCustomerAccountStatement, isReceipt, certificateId) => {
  return (dispatch) => {
    dispatch(getFilesInfoStart());

    const receiptIdParams = receiptId ? `&receiptId=${receiptId}` : '';
    const receiptIsCustomerAccountStatementParam = '&receiptIsCustomerAccountStatement=' + (receiptIsCustomerAccountStatement ? 'true' : 'false');
    const isReceiptParam = '&isReceipt=' + (isReceipt ? 'true' : 'false');
    const certificateParams = isGuid(certificateId) ? `&certificateId=${certificateId}` : '';

    const url =
      `${apiOptions.apiRoot}/send-files/get-files-info?` +
      receiptIdParams +
      receiptIsCustomerAccountStatementParam +
      isReceiptParam +
      certificateParams;

    axios
      .post(url, fileIds ? fileIds.filter((x) => x && x.trim().length > 0) : [])
      .then((response) => {
        dispatch(getFilesInfoSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getFilesInfoFail(err));
      });
  };
};

const getSendPolicyPackageInfoStart = () => {
  return {
    type: actionTypes.SEND_FILES_GET_SEND_POLICY_PACKAGE_INFO_START,
  };
};

const getSendPolicyPackageInfoSuccess = (data) => {
  return {
    type: actionTypes.SEND_FILES_GET_SEND_POLICY_PACKAGE_INFO_SUCCESS,
    data: data,
  };
};

const getSendPolicyPackageInfoFail = (error) => {
  return {
    type: actionTypes.SEND_FILES_GET_SEND_POLICY_PACKAGE_INFO_FAIL,
    error: error,
  };
};

export const getSendPolicyPackageInfo = (params) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getSendPolicyPackageInfoStart());
      axios
        .get(`/send-files/get-send-policy-package-info`, { params })
        .then((response) => {
          dispatch(getSendPolicyPackageInfoSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getSendPolicyPackageInfoFail(err));
          reject(err);
        });
    });
  };
};

const sendCertificateFilesStart = () => {
  return {
    type: actionTypes.SEND_CERTIFICATE_FILES_START,
  };
};

const sendCertificateFilesSuccess = (data) => {
  return {
    type: actionTypes.SEND_CERTIFICATE_FILES_SUCCESS,
    data: data,
  };
};

const sendCertificateFilesFail = (error) => {
  return {
    type: actionTypes.SEND_CERTIFICATE_FILES_FAIL,
    error: error,
  };
};

export const sendCertificateFiles = (params) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(sendCertificateFilesStart());

      axios
      .post(`${apiOptions.apiRoot}/send-files/link-certificate-files`, params)
      .then((response) => {
        dispatch(sendCertificateFilesSuccess(response.data));
        resolve(response.data);
      })
      .catch((err) => {
        dispatch(sendCertificateFilesFail(err));
        reject(err);
      });
    });
  };
}